import React, { useEffect, useState } from "react";
import { Link } from "gatsby";
import { gsap } from "gsap";
import { useCurrentSlug, useCurrentURI } from "../hooks/getLocation";
import { toggleAccordion } from "../utils";


const Header = ({ sliceContext }) => {
  const arheadMenu = sliceContext?.arpriMenuData || [];
  const armobileMenu = sliceContext?.armobileNode || [];
  const aroptions = sliceContext?.aroptions || [];

  const currentSlug = useCurrentSlug();
  const currentURI = useCurrentURI();


  const arheaderMainLink = arheadMenu && arheadMenu.slice(0, 4);
  const arheaderSecLink = arheadMenu && arheadMenu.slice(4);

  const [isExpanded, setIsExpanded] = useState(false);
  const handleTitleClick = () => {
    setIsExpanded((prev) => !prev); // Toggle the class
  };

  useEffect(() => {
    const menuAnimation = gsap.timeline({ paused: true });
    const menuAnimationBack = gsap.timeline({ paused: true, reversed: true });
    const navMain = document.getElementById("custom-menu");

    gsap.set(".custom-link.has-child", { x: 30, opacity: 0 });

    menuAnimation
      .from(navMain, { x: "110%", duration: 0.4 })
      .to(navMain, { duration: 0.8, x: 0 }) //
      .to(".custom-link.has-child", {
        duration: 0.4,
        x: 0,
        opacity: 1,
        stagger: 0.1,
        ease: "power4.out",
        delay: -0.8,
      });

    menuAnimationBack
      .to(".custom-link.has-child", {
        duration: 0.4,
        x: 30,
        opacity: 0,
        stagger: 0.1,
      })
      .to(navMain, { duration: 0.4, x: "110%", delay: -0.5 });

    

    document
      .getElementById("burgermenu")
      .addEventListener("click", function () {
        var thisParent = this.parentElement;
        thisParent.classList.add("out");
        document.querySelector("nav.main-nav").classList.add("open-menu");

        menuAnimation.restart();
      });

    document.getElementById("menuclose").addEventListener("click", function () {
      var thisParent = document.getElementById("burgermenu");
      thisParent.classList.remove("out");
      document.querySelector("nav.main-nav").classList.remove("open-menu");

      menuAnimationBack.restart();
    });
  }, []);

  useEffect(() => {
    var calHeight = 0;
    document.querySelectorAll("nav.main-nav li.has-child > a").forEach((item) => {
      item.addEventListener("click", function (e) {
        e.preventDefault();
  
        const parent = item.parentNode;
  
        document.querySelectorAll("nav.main-nav li.has-child.expand").forEach((expandedItem) => {
          if (expandedItem !== parent) {
            expandedItem.classList.remove("expand");
            const otherChild = expandedItem.querySelector(".has-children");
            if (otherChild) {
              otherChild.style.display = "none";
            }
          }
        });
  
        const child = parent.querySelector(".has-children");
        if (parent.classList.contains("expand")) {
          parent.classList.remove("expand");
          setTimeout(() => {
            child.style.display = "none";
          }, 200);
        } else {
          child.style.display = "block";
          parent.classList.add("expand");
        }
  
        toggleAccordion(parent, "nav.main-nav ul > li.has-child .ul-wrap > ul", "expand");
        toggleAccordion(parent, "nav.main-nav ul > li.has-child .content-div .link-wrapper", "act");
      });
    });
  }, []);


  
  return (
    <>
      <noscript
        key="gtm-noscript"
        dangerouslySetInnerHTML={{
          __html: `
          <iframe src="https://www.googletagmanager.com/ns.html?id=${process.env.GATSBY_GMT_CODE}"
            height="0" width="0" style="display:none;visibility:hidden"></iframe>
        `,
        }}
      />

      <div id="burgermenu" className="menu">
        <div
          className="menu-trg fix-el"
          style={{ transform: "translate(0px, 0px)", opacity: 1 }}
        >
          <div className="menu-trg__hold">
            <div
              className="line line-0"
              style={{
                transformOrigin: "0% 0%",
                transform: "translate(0px, 0px)",
              }}
            ></div>
            <div
              className="line line-1"
              style={{
                transformOrigin: "0% 0%",
                transform: "translate(0px, 0px)",
              }}
            ></div>
            <div
              className="line line-2"
              style={{
                transformOrigin: "0% 0%",
                transform: "translate(0px, 0px)",
              }}
            ></div>
          </div>
        </div>
      </div>

      <nav className="main-nav">
        <div className="nav-header">
          <svg
            id="menuclose"
            className="close-btn"
            xmlns="http://www.w3.org/2000/svg"
            width="34.594"
            height="34.592"
            viewBox="0 0 34.594 34.592"
          >
            <g
              id="Group_6368"
              data-name="Group 6368"
              transform="translate(-373.09 -29)"
            >
              <path
                id="Path_715"
                data-name="Path 715"
                d="M2.635,0h19.19A2.635,2.635,0,0,1,24.46,2.636v19.19a2.635,2.635,0,0,1-2.635,2.635H2.636A2.635,2.635,0,0,1,0,21.825V2.635A2.635,2.635,0,0,1,2.635,0Z"
                transform="translate(390.387 29) rotate(45)"
                stroke="#fff"
                fill="none"
              />
              <g
                id="Group_6359"
                data-name="Group 6359"
                transform="translate(1.656 1.397)"
              >
                <path
                  id="Path_725"
                  data-name="Path 725"
                  d="M383.661,39.83,393.8,49.969"
                  fill="none"
                  stroke="#fff"
                  strokeWidth="1"
                />
                <path
                  id="Path_726"
                  data-name="Path 726"
                  d="M383.661,39.83,393.8,49.969"
                  transform="translate(433.63 -343.831) rotate(90)"
                  fill="none"
                  stroke="#fff"
                  strokeWidth="1"
                />
              </g>
            </g>
          </svg>
        </div>
        <div className="menu-wrap">
          <ul className="main-nav-links accordion">
            {armobileMenu &&
              armobileMenu.slice(0, 4).map((item, index) => (
                <li key={`fsdfsfs` + index} className={"custom-link"}>
                  <Link
                    to={item.path}
                    className="toggle"
                    activeClassName="current-menu-item"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}

            <li className="custom-link has-child">
              <Link to={armobileMenu[4].path} className="toggle bold">
                {armobileMenu[4].label}
              </Link>

              <div className="inner has-children">
                <div className="child-div">
                  <div className="transperent-div"></div>
                  <div className="content-div">
                    <div className="ul-wrap">
                      <ul>
                        <li>
                          <a href="#" className="bold-title bold">
                            منتجات
                          </a>
                        </li>

                        {armobileMenu &&
                          armobileMenu[4].children
                            .slice(0, 4)
                            .map((item, index) => (
                              <li key={`opuodfd` + index}>
                                <Link href={item.path}>{item.label}</Link>
                              </li>
                            ))}
                      </ul>
                    </div>
                    <div className="link-wrapper">
                      <Link
                        to={armobileMenu && armobileMenu[4].children[4].path}
                        className="bold more-link"
                      >
                        {armobileMenu && armobileMenu[4].children[4].label}
                        <span className="arrow-icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12.908"
                            height="12.908"
                            viewBox="0 0 12.908 12.908"
                          >
                            <g
                              id="Icon_feather-arrow-down-left"
                              data-name="Icon feather-arrow-down-left"
                              transform="translate(11.908 12.201) rotate(180)"
                            >
                              <path
                                id="Path_138"
                                data-name="Path 138"
                                d="M11.2,0,0,11.2"
                                transform="translate(0 0)"
                                fill="none"
                                stroke="#18529f"
                                strokeLinejoin="round"
                                strokeWidth="2"
                              ></path>

                              <path
                                id="Path_139"
                                data-name="Path 139"
                                d="M11.2,11.2H0V0"
                                transform="translate(0 0)"
                                fill="none"
                                stroke="#18529f"
                                strokeLinejoin="round"
                                strokeWidth="2"
                              ></path>
                            </g>
                          </svg>
                        </span>
                      </Link>
                      <Link
                        to={armobileMenu && armobileMenu[4].children[5].path}
                        className="bold more-link"
                      >
                        {armobileMenu && armobileMenu[4].children[5].label}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li className="custom-link has-child">
              <Link to={armobileMenu[5].path} className="toggle bold">
                {armobileMenu[5].label}
              </Link>
              <div className="inner has-children">
                <div className="child-div">
                  <div className="transperent-div"></div>
                  <div className="content-div">
                    <div className="ul-wrap">
                      <ul>
                        <li>
                          <a href="#" className="bold-title">
                            منتجات
                          </a>
                        </li>
                        {armobileMenu &&
                          armobileMenu[5].children
                            .slice(0, 9)
                            .map((item, index) => (
                              <li key={`dgdfd` + index}>
                                <Link href={item.path}>{item.label}</Link>
                              </li>
                            ))}
                      </ul>
                     
                    </div>
                    <div className="link-wrapper">
                      <Link
                        to={armobileMenu && armobileMenu[5].children[10].path}
                        className="bold more-link"
                      >
                        {armobileMenu && armobileMenu[5].children[10].label}
                      </Link>
                      <Link
                        to={armobileMenu && armobileMenu[5].children[11].path}
                        className="bold more-link"
                      >
                        {armobileMenu && armobileMenu[5].children[11].label}
                      </Link>
                      <Link
                        to={armobileMenu && armobileMenu[5].children[11].path}
                        className="bold more-link"
                      >
                        {armobileMenu && armobileMenu[5].children[11].label}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            {armobileMenu &&
              armobileMenu.slice(6, 9).map((item, index) => (
                <li key={`wetdfb` + index} className={"custom-link"}>
                  <Link
                    to={item.path}
                    className="toggle bold"
                    activeClassName="current-menu-item"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}

            <li className="custom-link has-child client-login-mob">
              <Link to={armobileMenu[9].path} className="toggle bold">
                {armobileMenu[9].label}
              </Link>

              <div className="inner has-children">
                <div className="child-div">
                  <div className="transperent-div"></div>
                  <div className="content-div">
                    <div className="ul-wrap">
                      <ul className="app-mobile">
                       

                        {armobileMenu &&
                          armobileMenu[9].children
                            .slice(0, 9)
                            .map((item, index) => (
                              <>
                                <li key={`afsd` + index}>
                                  <Link href={item.path} target="_blank">{item.label}</Link>
                                </li>
                                {index=== 1 &&
                                <li className="app-mob-logo" key={`dsfsd` + index}>
                                  <a
                                    href="https://play.google.com/store/apps/details?id=net.metaquotes.metatrader5&hl=en&referrer=ref_id%3D5188631200404228860%26hl%3Den%26utm_source%3Dwww.metatrader5.com%26utm_campaign%3Dinstall.metaquotes&pli=1"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      src="https://wp.orientfinance.com/wp-content/uploads/2024/11/play-store-new-2.png"
                                      alt="play store"
                                    />
                                  </a>
                                  <a
                                    href="https://apps.apple.com/ae/app/metatrader-5/id413251709"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      src="https://wp.orientfinance.com/wp-content/uploads/app-store-new-3.png"
                                      alt="app store Logo"
                                    />
                                  </a>
                                </li>
                              }
                              </>
                            ))}
                      </ul>
                    </div>

                  </div>
                </div>
              </div>
            </li>
            <li className="ar-link"><a class="head-open-acc btn-fill" href="/">En</a></li>
          </ul>
         
         
        </div>
      </nav>

      <header className="ar">
        <div className="container d-flex">
          <a href={"/ar/"} className="logo-orient">
            <img
              src={aroptions && aroptions.mediaItemUrl}
              alt="Orient Finance Logo"
            />
          </a>

          <div className="head-menu-wrapper">
            <div className="left-menu">
              <nav className="top-menu">
                <ul className="d-flex">
                  {arheaderMainLink.map((item, index) => (
                    <li
                      key={`qqrwq` + index}
                      className={`${currentSlug === item.path ? "active" : ""} ${currentURI.includes(item.path) ? "active" : ""}`}
                    >
                      <Link to={item.path} activeClassName="current-menu-item">
                        {item.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </nav>

                 {/* { console.log(headerSecLink.children,"headerSecLink")} */}
              <nav className="btm-menu">
                <ul className="d-flex">
                  <li className={`has-child ${currentURI.includes(arheaderSecLink[0].path) ? "active" : ""}`}>
                    <a href={arheaderSecLink[0].path}>{arheaderSecLink[0].label}</a>
                    <div className="child-div">
                      <div className="transperent-div"></div>
                      <div className="content-div">
                        <div className="ul-wrap">
                          <ul>
                            <li>
                              <a href="#" className="bold-title">
                                منتجات
                              </a>
                            </li>
                            {arheaderSecLink &&
                              arheaderSecLink[0].children
                                .slice(0, 4)
                                .map((item, index) => (
                                  <li key={`dgfhfdj` + index}>
                                    <a href={item.path}>{item.label}</a>
                                  </li>
                                ))}
                          </ul>
                        </div>
                        <div className="link-wrapper ed">
                          <Link
                            to={
                              arheaderSecLink && arheaderSecLink[0].children[4].path
                            }
                            className="bold more-link"
                          >
                            {arheaderSecLink &&
                              arheaderSecLink[0].children[4].label}
                            <span className="arrow-icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12.908"
                                height="12.908"
                                viewBox="0 0 12.908 12.908"
                              >
                                <g
                                  id="Icon_feather-arrow-down-left"
                                  data-name="Icon feather-arrow-down-left"
                                  transform="translate(11.908 12.201) rotate(180)"
                                >
                                  <path
                                    id="Path_138"
                                    data-name="Path 138"
                                    d="M11.2,0,0,11.2"
                                    transform="translate(0 0)"
                                    fill="none"
                                    stroke="#18529f"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                  ></path>

                                  <path
                                    id="Path_139"
                                    data-name="Path 139"
                                    d="M11.2,11.2H0V0"
                                    transform="translate(0 0)"
                                    fill="none"
                                    stroke="#18529f"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                  ></path>
                                </g>
                              </svg>
                            </span>
                          </Link>
                          <Link
                            to={
                              arheaderSecLink && arheaderSecLink[0].children[5].path
                            }
                            className="bold more-link"
                          >
                            {arheaderSecLink &&
                              arheaderSecLink[0].children[5].label}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </li>

                  <li className={`has-child ${currentURI.includes(arheaderSecLink[1].path) ? "active" : ""}`}>
                    <Link to={arheaderSecLink[1].path}>
                      {arheaderSecLink[1].label}
                    </Link>
                    <div className="child-div">
                      <div className="transperent-div"></div>
                      <div className="content-div">
                        <div className="ul-wrap">
                          <ul>
                            <li>
                              <a href="#" className="bold-title">
                                منتجات
                              </a>
                            </li>
                            {arheaderSecLink &&
                              arheaderSecLink[1].children
                                .slice(0, 4)
                                .map((item, index) => (
                                  <li key={`f33w` + index}>
                                    <a href={item.path}>{item.label}</a>
                                  </li>
                                ))}
                          </ul>
                          <ul>
                            {arheaderSecLink &&
                              arheaderSecLink[1].children
                                .slice(4, 9)
                                .map((item, index) => (
                                  <li key={`ljlex` + index}>
                                    <a href={item.path}>{item.label}</a>
                                  </li>
                                ))}
                          </ul>
                        </div>
                        <div className="link-wrapper">
                        <Link
                            to={arheaderSecLink && arheaderSecLink[1].children[9].path}
                            className="bold more-link">
                            {arheaderSecLink &&
                              arheaderSecLink[1].children[9].label}
                          </Link>
                          <Link
                            to={arheaderSecLink && arheaderSecLink[1].children[10].path}
                            className="bold more-link">
                            {arheaderSecLink &&
                              arheaderSecLink[1].children[10].label}
                          </Link>

                          <Link
                            to={arheaderSecLink &&
                              arheaderSecLink[1].children[11].path}
                            className="bold more-link"
                          >
                            {arheaderSecLink &&
                              arheaderSecLink[1].children[11].label}
                          </Link>
                          {/* <Link
                            to={
                              headerSecLink &&
                              headerSecLink[1].children[12].path
                            }
                            className="bold more-link"
                          >
                            {headerSecLink &&
                              headerSecLink[1].children[12].label}
                          </Link> */}
                        </div>
                      </div>
                    </div>
                  </li>

                  <li className={` ${currentURI.includes(arheaderSecLink[2].path) ? "active" : ""}`}>
                    <a href={arheaderSecLink[2].path}>{arheaderSecLink[2].label}</a>
                  </li>

                  <li className={`has-child tools-link ${currentURI.includes(arheaderSecLink[3].path) ? "active" : ""}`}>
                    <a href={arheaderSecLink[3].path}>{arheaderSecLink[3].label}</a>
                    <div className="child-div">
                      <div className="transperent-div"></div>
                      <div className="content-div">
                        <div className="ul-wrap">
                          <ul>
                            {arheaderSecLink &&
                              arheaderSecLink[3].children
                                .slice(0, 4)
                                .map((item, index) => (
                                  <li key={`lefejlx` + index}>
                                    <Link href={item.path}>{item.label}</Link>
                                  </li>
                                ))}
                          </ul>
                          <ul>
                            {arheaderSecLink &&
                              arheaderSecLink[3].children
                                .slice(4)
                                .map((item, index) => (
                                  <li
                                    key={`ljkgjllx` + index}
                                    className="link-title txt-b"
                                  >
                                    <Link to={item.path}>{item.label}</Link>
                                  </li>
                                ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className={`${currentURI.includes(arheaderSecLink[4].path) ? "active" : ""}`}>
                    <Link to={arheaderSecLink[4].path}>
                      {arheaderSecLink[4].label}
                    </Link>
                  </li>
                </ul>
              </nav>
            </div>

            <div className="right-menu">
              <ul className="head-btn d-flex">
                <li className="has-child">
                  <a
                    href={"javascript:void(0)"}
                    className="client-login btn-border"
                  >
                    {arheaderSecLink[5].label}
                  </a>

                  <div className="child-div">
                    <div className="content-div">
                      <div className="ul-wrap">
                        <ul>
                          {arheaderSecLink &&
                            arheaderSecLink[5].children.map((item, index) => (
                              <li key={`gfgf4s` + index}>
                                {index === 0 && (
                                  <a href={item.path} target="_blank" rel="noopener noreferrer">
                                    {item.label}
                                  </a>
                                )}
                                {index === 1 && (
                                  <>
                                    <a
                                      className="mt5-title"
                                      onClick={handleTitleClick}
                                      style={{ cursor: 'pointer' }} // Optional: to indicate clickability
                                    >
                                      {item.label}
                                    </a>
                                    <div className={`apps ${isExpanded ? 'expand' : ''}`}>
                                      
                                      <a
                                        href="https://download.mql5.com/cdn/web/metaquotes.ltd/mt5/mt5setup.exe?utm_source=www.metatrader5.com&utm_campaign=download"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <img
                                          src="https://wp.orientfinance.com/wp-content/uploads/2024/11/windows-logo.jpg"
                                          alt="Windows Logo"
                                        />
                                      </a>
                                      <a
                                        href="https://download.mql5.com/cdn/web/metaquotes.ltd/mt5/MetaTrader5.pkg.zip?utm_source=www.metatrader5.com&utm_campaign=download.mt5.macos"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <img
                                          src="https://wp.orientfinance.com/wp-content/uploads/2024/11/mac-logo.jpg"
                                          alt="Mac Logo"
                                        />
                                      </a>
                                    </div>
                                  </>
                                )}
                              </li>
                            ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </li>

                <li>
                  <Link
                    to={arheaderSecLink[6].path}
                    className="head-open-acc btn-fill"
                  >
                    {arheaderSecLink[6].label}
                    <span className="arrow-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12.908"
                        height="12.908"
                        viewBox="0 0 12.908 12.908"
                      >
                        <g
                          id="Icon_feather-arrow-down-left"
                          data-name="Icon feather-arrow-down-left"
                          transform="translate(11.908 12.201) rotate(180)"
                        >
                          <path
                            id="Path_138"
                            data-name="Path 138"
                            d="M11.2,0,0,11.2"
                            transform="translate(0 0)"
                            fill="none"
                            stroke="#18529f"
                            strokeLinejoin="round"
                            strokeWidth="2"
                          />

                          <path
                            id="Path_139"
                            data-name="Path 139"
                            d="M11.2,11.2H0V0"
                            transform="translate(0 0)"
                            fill="none"
                            stroke="#18529f"
                            strokeLinejoin="round"
                            strokeWidth="2"
                          />
                        </g>
                      </svg>
                    </span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <ul className="site-btn">
              <li className="ar"><a class="head-open-acc btn-fill" href="/">English</a></li>
          </ul>
        </div>
      </header>
    </>
  );
};

export default Header;
